import React, { createContext, useContext, useState, useCallback } from 'react';

type Toast = { id: number; text: string };
const ToastCtx = createContext<{ show: (text: string) => void } | null>(null);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [items, setItems] = useState<Toast[]>([]);
  const show = useCallback((text: string) => {
    const id = Date.now();
    setItems((prev) => [...prev, { id, text }]);
    setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), 2400);
  }, []);
  return (
    <ToastCtx.Provider value={{ show }}>
      {children}
      <div className="fixed bottom-3 right-3 space-y-2 z-[60]">
        {items.map((t) => (
          <div
            key={t.id}
            className="rounded-md px-3 py-2 text-sm shadow-lg border"
            style={{ background: '#151518', color: '#EDEDEF', borderColor: '#232329' }}
          >
            {t.text}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToastLite() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToastLite must be used within <ToastProvider>');
  return ctx;
}
